export default __webpack_public_path__ + "static/media/mail.fae35aae.svg";